export const FETCH_VENTAS_REQUEST = "FETCH_VENTAS_REQUEST";
export const FETCH_VENTAS_SUCCESS = "FETCH_VENTAS_SUCCESS";
export const FETCH_VENTAS_FAILURE = "FETCH_VENTAS_FAILURE";
